
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/burgare",
      function () {
        return require("private-next-pages/burgare/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/burgare"])
      });
    }
  